<div class="alpr-hit-details-card">
  <div class="hit-details-header">
    <div class="hit-details-title">{{ alprTitle }}</div>
    <div class="menu-container">
      <sn-icon-button
        [matMenuTriggerFor]="alprMenu"
        [matMenuTriggerData]="{ alarm: alarm }"
        (click)="$event.stopPropagation()"
      >
        <sn-icon>more_vert</sn-icon>
      </sn-icon-button>
    </div>
  </div>

  <!-- Standalone ALPR Media Card Component -->
  <fs-alpr-media-card #mediaCard [alarm]="alarm" [hideActions]="hideActions"> </fs-alpr-media-card>

  <div class="hit-details-content">
    <!-- Left Column: License Plate Component -->
    <fs-license-plate-details
      [alarm]="alarm"
      (searchPlate)="onSearchPlate($event)"
      (copyPlate)="onCopyPlate($event)"
      class="left-column"
    >
    </fs-license-plate-details>

    <!-- Right Column: Alert Details -->
    <div class="right-column">
      <!-- Hotlist Information -->
      <div class="hotlist-section" *ngIf="hasHotlistData">
        <div class="hotlist-category" *ngIf="hasHotlistCategory">{{ hotlistCategory }}</div>
        <div class="hotlist-name" *ngIf="hasHotlistName">{{ hotlistName }}</div>
      </div>

      <!-- Hit Details -->
      <div class="hit-details-section">
        <div class="vehicle-details">
          <span>{{ vehicleMake }}</span>
          <span>{{ vehicleColor }}</span>
          <span>{{ vehicleType }}</span>
        </div>
        <div>
          <ng-container *ngIf="cameraName">{{ cameraName }}</ng-container>
        </div>
        <div>
          <ng-container *ngIf="cameraSource">{{ cameraSource }}</ng-container>
        </div>
      </div>

      <!-- Timestamp -->
      <div class="timestamp-section">
        <span>
          <ng-container *ngIf="relativeTime">{{ relativeTime }}</ng-container> </span
        ><span>
          <ng-container *ngIf="absoluteTime">{{ absoluteTime }}</ng-container>
        </span>
      </div>
    </div>
  </div>
</div>

<mat-menu #alprMenu="matMenu" xPosition="before">
  <ng-template matMenuContent let-alarm="alarm">
    <!-- Image Mode Items -->
    <ng-container *ngIf="!isFlipped">
      <button *ngIf="isLprImage" mat-menu-item (click)="openEnlargedImageDialog()">
        <sn-icon>open_in_new</sn-icon>
        <span>{{ 'map.alarmCard.menu.enlargeImage' | t }}</span>
      </button>
      <button mat-menu-item (click)="showMetadata()">
        <sn-icon>info</sn-icon>
        <span>{{ 'map.alarmCard.menu.metadata' | t }}</span>
      </button>
    </ng-container>

    <!-- Details Mode Items -->
    <ng-container *ngIf="isFlipped">
      <button mat-menu-item (click)="turn()">
        <sn-icon>visibility</sn-icon>
        <span>{{ 'map.alarmCard.menu.hitDetails' | t }}</span>
      </button>
      <button *ngIf="isLprImage" mat-menu-item (click)="openEnlargedImageDialog()">
        <sn-icon>open_in_new</sn-icon>
        <span>{{ 'map.alarmCard.menu.enlargeImage' | t }}</span>
      </button>
    </ng-container>

    <!-- Common Items -->
    <button mat-menu-item (click)="openAlarmGrid()">
      <sn-icon>apps</sn-icon>
      <span>{{ 'common.grid' | t }}</span>
    </button>
    <button mat-menu-item (click)="showOnMap()" *ngIf="alarm.geometry && hasCoordinates">
      <sn-icon>gps_fixed</sn-icon>
      <span>{{ 'common.showOnMap' | t }}</span>
    </button>
    <button *ngIf="autoDockMaxCameras > 0" mat-menu-item (click)="dockCameras()">
      <sn-icon>videocam</sn-icon>
      <span>{{ 'common.dockCameras' | t }}</span>
    </button>
    <button mat-menu-item (click)="openSendForm(alarm)">
      <sn-icon>send</sn-icon>
      <span>{{ 'map.alarmCard.menu.sendTo' | t }}</span>
    </button>
    <button mat-menu-item (click)="closeAlert(alarm)">
      <sn-icon>close</sn-icon>
      <span>{{ 'common.close' | t }}</span>
    </button>
  </ng-template>
</mat-menu>
